export const OUTPUTS_SELECT_URL = "OUTPUTS_SELECT_URL";
